import React, { FC, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { EntityHeader, HasSidebarLayout, ContractorNewForm } from 'src/components'
import { useNewContractorRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'
import { ContractorCreationV2 } from '../api'
import { ContractorNewState } from '../components/forms/contractor/new'

interface OwnerUserLocationState {
  ownerUser?: {
    name: string
    phone: string
    email: string
  }
}

const NewContractor: FC = () => {
  document.title = 'CLīMIT Admin Panel - New contractor'
  const navigate = useNavigate()
  const location = useLocation()
  const addMessage = useAddPopupMessage()
  const request = useNewContractorRequest({
    options: {
      onSuccess: () => {
        navigate(-1)
      },
      onError: ({ message: text }) => {
        addMessage({ text, type: 'error' })
      }
    }
  })

  const ownerUser = (location.state as OwnerUserLocationState)?.ownerUser

  const initialValues = useMemo<ContractorNewState | undefined>(() => {
    if (!ownerUser) return undefined
    const phone = ownerUser.phone || ''
    const normalizedPhone = phone && !phone.startsWith('+') ? `+${phone}` : phone
    return {
      ownerName: ownerUser.name || '',
      ownerPhone: normalizedPhone,
      ownerEmail: ownerUser.email || '',
      type: 'standalone',
      name: ''
    }
  }, [ownerUser])

  const onSubmit = (data: ContractorCreationV2, photo: File | null) => {
    if (photo) {
      request.mutate({ ...data, photos: [photo] })
    } else {
      request.mutate(data)
    }
  }
  return (
    <HasSidebarLayout>
      <EntityHeader title="Create new contractor" />
      <ContractorNewForm onSubmit={onSubmit} isLoading={request.isLoading} initialValues={initialValues} />
    </HasSidebarLayout>
  )
}

export default NewContractor
